export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_SET_LOADING = 'AUTH_SET_LOADING';
export const AUTH_SET_USER = 'AUTH_SET_USER';

export const setAuthLoading = loading => ({
  type: AUTH_SET_LOADING,
  payload: loading,
});

export const setAuthUser = user => ({
  type: AUTH_SET_USER,
  payload: user,
});

export const authLoginSuccess = (user, token) => ({
  type: AUTH_LOGIN_SUCCESS,
  payload: { user, token },
});

export const authLoginFailure = error => ({
  type: AUTH_LOGIN_FAILURE,
  payload: error,
});

export const authLogout = () => ({
  type: AUTH_LOGOUT,
});
